<template>
  <span></span>
</template>

<script>
import { mapActions } from 'vuex'
export default {
  name: "checkReceiptToken",
  mounted() {
    const value = this.$route.query['token']
    this.check72Hours(value)
      .then(res => {
        if (!res.response) {
          location.href = `/${this.$store.state.campaignURLName}/expired-page`
        }
      })
      .catch((e)=>{
        console.error(e)
        location.href = `/${this.$store.state.campaignURLName}`
      })
  },
  methods: {
    ...mapActions(['check72Hours'])
  }
}
</script>